import { Container } from "react-bootstrap"

const About = () => {
 return (
     <Container>
         <h2 id="about" className="text-center" style={{marginTop: '1em'}}>About</h2>
         <h3>At a Glance</h3>
         <p> The Honors Carolina Resume App simply searches resume templates 
             based off key skill or subject tags. The resulting peer vetted 
             resumes aid student in creating their own resumes. While resumes are
             a start, this app hopes to help in the creation of all recruiting 
             documents.
         </p>
         <h3>Detailed Breakdown</h3>
         <p>Our client, Honors Carolina, wants us to create a Browser Based tool, that 
             allows staff to add tags onto student submitted Resumes. Students will then
             use those tags to search for resumes that match the criteria of the resume 
             they are trying to build.
         </p>
         <ul>
             <li>Tackling the recruiting challenge
                 <ul>
                     <li>Most interviewers only look at resumes for 30 seconds</li>
                     <li>Clearing automated resume screens gets students in the door</li>
                     <li>Unstructured or messy resumes will not attract the eyes of the recruiting team</li>
                     <li>Students often struggle with breaking down their technical projects onto their resumes</li>
                     <li><strong>New resumes often struggle with providing pertinent info in 
                         short concise and impactful manor</strong></li>
                    <li><strong>Honors Carolina Resume App will provide student sourced and
                         vetted resumes that will serve as a template for writing new resumes</strong></li>
                 </ul>
             </li>
             <li>Technical Logistics
                 <ul>
                     <li>Web Application</li>
                     <li>Intended for students in Honors Carolina, the application will be accessed from
                         the Honors Carolina Website once complete
                     </li>
                 </ul>
             </li>
             <li>Goals
                 <ul>
                     <li>Create a website with user accounts for students, admin, and superuser</li>
                     <li>Integrate a cloud-based backend with a database service (tbd)</li>
                     <li>Have good test coverage and code coverage </li>
                     <li>Integrate with existing auth services if possible</li>
                 </ul>
             </li>
         </ul>
         <h3>Links</h3>
         <ul>
            <li><a href="https://comp523.cs.unc.edu/f21/clients/brumfield-slides.pdf" target="_blank" rel="noreferrer">Client Pitch</a></li>
            <li><a href="https://comp523.cs.unc.edu/f21/clients/brumfield.pdf" target="_blank" rel="noreferrer">COMP 523 Application</a></li>
            <li><a href="https://shibboleth-dept-honorscarolinaresumes.apps.cloudapps.unc.edu/" target="_blank" rel="noreferrer">Hosted Application (Carolina Cloud Apps)</a></li>
         </ul>
     </Container>
 )
}
export default About